import { render, staticRenderFns } from "./presaleList.vue?vue&type=template&id=5aaae16c&scoped=true&"
import script from "./presaleList.vue?vue&type=script&lang=js&"
export * from "./presaleList.vue?vue&type=script&lang=js&"
import style0 from "./presaleList.vue?vue&type=style&index=0&id=5aaae16c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaae16c",
  null
  
)

export default component.exports